var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Col, Select } from '@folio/stripes/components';
import React, { useMemo } from 'react';
import { Field, useField } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { useFeeFineOwners, useFeeFineTypes } from '../../api/queries';
export default function CriteriaFeeFineType(_a) {
    var prefix = _a.prefix;
    var feeFineOwners = useFeeFineOwners();
    var feeFineTypes = useFeeFineTypes();
    var intl = useIntl();
    var selectedOwner = useField("".concat(prefix, "feeFineOwnerId"), {
        subscription: { value: true },
        // provide default value for when the field is not yet initialized
        format: function (value) { return value !== null && value !== void 0 ? value : 'automatic'; },
    }).input.value;
    var ownersSelectOptions = useMemo(function () {
        var defaultOption = {
            label: intl.formatMessage({
                id: 'ui-plugin-bursar-export.bursarExports.criteria.type.automatic',
            }),
            value: 'automatic',
        };
        if (!feeFineOwners.isSuccess) {
            return [defaultOption];
        }
        return __spreadArray([
            defaultOption
        ], feeFineOwners.data
            .map(function (owner) { return ({
            label: owner.owner,
            value: owner.id,
        }); })
            .sort(function (a, b) { return a.label.localeCompare(b.label); }), true);
    }, [feeFineOwners, intl]);
    var typeSelectOptions = useMemo(function () {
        if (!feeFineTypes.isSuccess) {
            return [];
        }
        if (selectedOwner === 'automatic') {
            return feeFineTypes.data
                .filter(function (type) { return type.automatic; })
                .map(function (type) { return ({
                label: type.feeFineType,
                value: type.id,
            }); });
        }
        return feeFineTypes.data
            .filter(function (type) { return type.ownerId === selectedOwner; })
            .map(function (type) { return ({
            label: type.feeFineType,
            value: type.id,
        }); });
    }, [selectedOwner, feeFineTypes]);
    var typeSelectOptionsForDisplay = useMemo(function () { return __spreadArray([{ label: '', value: undefined }], typeSelectOptions, true).sort(function (a, b) { return a.label.localeCompare(b.label); }); }, [typeSelectOptions]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Col, { xs: 12, md: 6 },
            React.createElement(Field, { name: "".concat(prefix, "feeFineOwnerId"), defaultValue: "automatic" }, function (fieldProps) { return (React.createElement(Select, __assign({}, fieldProps, { fullWidth: true, marginBottom0: true, required: true, label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.criteria.select.owner" }), dataOptions: ownersSelectOptions }))); })),
        React.createElement(Col, { xs: 12, md: 6 },
            React.createElement(Field, { name: "".concat(prefix, "feeFineTypeId") }, function (fieldProps) { return (React.createElement(Select, __assign({}, fieldProps, { fullWidth: true, marginBottom0: true, required: true, label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.criteria.select.type" }), dataOptions: typeSelectOptionsForDisplay }))); }))));
}
